import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import HHDisplayPercentage from 'components/common/HHDisplayPercentage'
import HHDisplayMoney from 'components/common/HHDisplayMoney'
import { getIsFeeRatePercentage } from 'components/pricing/LateFees/CreateEditLateFeesDialog/utils'

const RenderLateFeeAmount = ({ feeRate, amountCents = 0, amountPercent = 0 }) => {
  const isFeeRatePercentage = useMemo(() => getIsFeeRatePercentage(feeRate), [feeRate])

  return isFeeRatePercentage ? <HHDisplayPercentage value={amountPercent} /> : <HHDisplayMoney value={amountCents} formatToDollars />
}

RenderLateFeeAmount.propTypes = {
  feeRate: PropTypes.string,
  amountCents: PropTypes.number,
  amountPercent: PropTypes.number,
}

export default RenderLateFeeAmount
